import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactTooltip from 'react-tooltip';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { API } from 'aws-amplify';
import { FaCircle } from 'react-icons/fa';
import { FaInfoCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import Map from '../../Util/Map'
import SingleSwitch from './SingleSwitch'
import JobIds from './JobIds'
import { FileUploadRing } from '../../Util/LoadingIcons'


export default class MetStationMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openMap: false,
            requestStatus: false,
            surfaceStationList : [],
            upperAirStationList : [],
        };
        this.changeBoolean = this.changeBoolean.bind(this);

    }

    api_post_metsite() {
        let request = {
            'latlon' : [parseFloat(this.props.latitude), parseFloat(this.props.longitude)]

        }

        if (parseFloat(this.props.latitude) > 58 || parseFloat(this.props.latitude) < 24 ||
            parseFloat(this.props.longitude) > -66 || parseFloat(this.props.longitude) < -126){
            this.setState({requestStatus: 'badll'})
        }else{
            let options = {
                body: request,
                headers: {},
                response: true
            }
            this.setState({requestStatus: 'uploading'})

            API.post("AQcast", "/request/metsite/", options)
                            .then(response => {
                                this.setState({
                                    surfaceStationList: response.data.surface_stations,
                                    upperAirStationList: response.data.upperair_stations,
                                    requestStatus: 'complete'
                                })
                                console.log(JSON.stringify(this.state.surfaceStationList))
                            })
                            .catch(error => {
                                console.log(error)
                                this.setState({
                                    requestStatus: 'error'
                                })
                            })
        }
    }

    changeBoolean(varName){
        let boolValue = this.state[varName]
        this.setState({[varName]: !boolValue})
    }

    displayRequestStatus() {
        if (this.state.requestStatus === 'badll'){
            return <i style={{color: 'red'}}>Coordinates must be in the contiguous US.</i>
        } else if (this.state.requestStatus === 'error'){
            return <FaTimesCircle style={{color:'red'}}/>
        } else if(this.state.requestStatus === 'complete'){
            return <FaCheckCircle style={{color:'green'}}/>
        } else if(this.state.requestStatus === 'uploading'){
            return <FileUploadRing/>
        } else {
            return null
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className="form-input-container" >
                <div className="form-input-container">
                <div>
                    <b>Previously Created Meteorology (optional) <FaInfoCircle data-tip data-for='previousMet'/> </b>

                    <ReactTooltip id='previousMet' place="right" type="light" effect="solid">
                        This option does NOT use a Met Token.
                    </ReactTooltip>
                </div>
                <JobIds
                    classes={classes}
                    handleInputChange={this.props.handleInputChange}
                    value={this.props.previousMet}
                    title='Select meteorology from previous job:'
                    name='previousMet'
                    model={this.props.model}
                />
                </div>

                <div><b> NWS Meteorological Station Options: <FaInfoCircle data-tip data-for='nws'/> </b>
                    <ReactTooltip id='nws' place="right" type="light" effect="solid">
                        If applicable: To show loaded project meteorology, hit the 'Find Closest Meteorological Sites' button.
                    </ReactTooltip>
                </div>
                <SingleSwitch
                    classes={classes}
                    handleInputChange={this.props.handleInputChange}
                    label='Use the default Meteorological Stations instead of choosing from the list below.'
                    name='useDefaultMetCheck'
                    value={this.props.useDefaultMetCheck}
                    />

                <div>
                    <FormControl className={classNames(classes.margin, classes.formControl)}>
                        <InputLabel shrink>Latitude</InputLabel>
                        <Input
                            data-tip data-for="latitude"
                            inputProps={{ min: "24", max: "58", step: "any" }}
                            type="number"
                            name="latitude"
                            value={this.props.latitude}
                            onChange={this.props.handleInputChange}/>
                    </FormControl>
                    <ReactTooltip id='latitude' place="bottom" type="light" effect="solid">
                        WGS84 Latitude in decimal degrees from -90 to 90.
                    </ReactTooltip>

                    <FormControl className={classNames(classes.margin, classes.formControl)}>
                        <InputLabel shrink>Longitude</InputLabel>
                        <Input
                            data-tip data-for="longitude"
                            inputProps={{ min: "-126", max: "-66", step: "any" }}
                            type="number"
                            name="longitude"
                            value={this.props.longitude}
                            onChange={this.props.handleInputChange}/>
                    </FormControl>
                    <ReactTooltip id='longitude' place="bottom" type="light" effect="solid">
                        WGS84 Longitude in decimal degrees from -180 to 180.
                    </ReactTooltip>

                    <Button
                        className={classNames(classes.margin)}
                        variant="outlined"
                        onClick={() => this.api_post_metsite()}
                    > Find Closest Meteorological Sites </Button>
                { this.state.requestStatus && this.displayRequestStatus()}
                </div>
                <div className={classNames(classes.margin, classes.metOptionsContainer)}>
                    {this.state.surfaceStationList.length > 0 && <b>Available Surface Stations:</b>}
                    <RadioGroup row key="surfaceStations" className={classNames(classes.margin)} >
                        {this.state.surfaceStationList.map(station => (
                            <FormControlLabel
                                key={station.name}
                                control={
                                    <Radio
                                        name={station.name}
                                        checked={JSON.parse(this.props.selectedSurfaceStation).name === station.name}
                                        onChange={this.props.handleInputChange}
                                        value={JSON.stringify(station)}
                                        inputProps={{radioname:"selectedSurfaceStation"}}
                                        color="primary"/>
                                }
                                label={station.name}/>
                        ))}
                    </RadioGroup>
                </div>
                <div className={classNames(classes.margin, classes.metOptionsContainer)}>
                    {this.state.upperAirStationList.length > 0 && <b>Available Upper Air Stations:</b>}
                    <RadioGroup row key="upperAirStations" className={classNames(classes.margin)}>
                        {this.state.upperAirStationList.map(station => (
                            <FormControlLabel
                                key={station.name}
                                control={
                                    <Radio
                                        name={station.name}
                                        checked={JSON.parse(this.props.selectedUpperAirStation).name === station.name}
                                        onChange={this.props.handleInputChange}
                                        value={JSON.stringify(station)}
                                        inputProps={{radioname:"selectedUpperAirStation"}}
                                        color="primary"/>
                                }
                                label={station.name}/>
                        ))}
                    </RadioGroup>
                </div>

                <Button
                    className={classNames(classes.marginLeft, classes.toggleMapButton)}
                    onClick={() => {this.setState({openMap: !this.state.openMap})}}
                    variant='outlined'
                    color="primary"
                > { this.state.openMap ? <span> Hide Map </span> : <span> Show Map </span> } </Button>

                <Collapse
                    in={this.state.openMap} timeout="auto"
                    className={classNames(classes.margin, classes.mapContainer)}
                    >
                    <div style={{height: '10px'}}></div>


                    <div className={classNames(classes.margin)}>
                        <div>
                            <p>Click on a point to display relevant information & select the Meteorological Station</p>
                        </div>

                        <FaCircle style={{color:'green'}}/> <b>Facility Location </b>
                        <FaCircle style={{color:'yellow'}}/> <b>Upper Air Stations </b>
                        <FaCircle style={{color:'blue'}}/> <b> Surface Stations </b>
                    </div>


                    <Map
                        classes={classes}
                        handleInputChange={this.props.handleInputChange}
                        facilityLat={this.props.latitude}
                        facilityLon={this.props.longitude}
                        surfaceStationList={this.state.surfaceStationList}
                        upperAirStationList={this.state.upperAirStationList}
                        selectedSurfaceStation={this.props.selectedSurfaceStation}
                        selectedUpperAirStation={this.props.selectedUpperAirStation}
                        changeBoolean={this.changeBoolean} />


                </Collapse>
            </div>
        );
    }
}
